export default "__VITE_ASSET__e7211f10__"